export default __webpack_public_path__ + "static/media/GCT_dining.98879b99.png";